export default __webpack_public_path__ + "static/media/footer-pattern.f7cd3e1c.svg";